import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { api } from "../../api/client";
import { PageHeader, StatePanel, Tag } from "../../components/ui";
import { t } from "../../i18n";
import { useAppStore } from "../../state/appStore";
export function PlansPage() {
  const { authenticated, result } = useAppStore();
  const reservations = useQuery({
    queryKey: ["reservations"],
    queryFn: api.reservations,
    enabled: authenticated,
    refetchInterval: authenticated ? 15000 : false,
  });
  return (
    <div className="page">
      <PageHeader
        eyebrow={t.reservations.eyebrow}
        title={t.reservations.title}
      />
      {!authenticated ? (
        <StatePanel
          icon="◇"
          title="Keep every plan together"
          body="Sign in to see saved plans, booking updates and past outings."
          action={
            <Link className="button button--primary" to="/auth">
              Sign in
            </Link>
          }
        />
      ) : (
        <>
          <h2>{t.reservations.active}</h2>
          {reservations.data?.map((item) => (
            <Link
              to={`/reservations/${item.id}`}
              className="reservation-card"
              key={item.id}
            >
              <div>
                <strong>
                  {new Intl.DateTimeFormat("en-LB", {
                    dateStyle: "medium",
                  }).format(
                    new Date(item.stages[0]?.startsAt ?? item.requestedAt),
                  )}
                </strong>
                <p>
                  {item.stages.length} booking requests ·{" "}
                  {item.walkInStages.length} walk-in stages
                </p>
              </div>
              <Tag tone="warning">In progress</Tag>
            </Link>
          ))}
          <h2>{t.reservations.saved}</h2>
          {result?.plans.map((plan) => (
            <Link to={`/plans/${plan.id}`} className="saved-plan" key={plan.id}>
              <div
                className="saved-plan__image"
                style={{
                  backgroundImage: `url(${plan.stages.find((stage) => stage.image)?.image ?? ""})`,
                }}
              />
              <div>
                <small>PLAN {plan.alternative}</small>
                <strong>{plan.reason}</strong>
                <p>{plan.stages.length} stages</p>
              </div>
              <span>›</span>
            </Link>
          ))}
          {!result && !reservations.data?.length && (
            <StatePanel
              title="No plans yet"
              body="Create a plan and it will appear here."
            />
          )}
        </>
      )}
    </div>
  );
}
